import { LazyFooter } from "src/website-apps/shared/components/footer";

/**
 * Home Page Layout Footer
 */
export const HomeLayoutFooter = ({ footerModel }) => (
  <LazyFooter
    companyLinks={footerModel?.companyLinks}
    supportLinks={footerModel?.supportLinks}
    getLocationSettingsUrl={footerModel?.getLocationSettingsUrl}
  />
);
